import { fade, makeStyles } from '@material-ui/core/styles';
import stiliDialog from '../../../../components/stiliDialog';

// Every step of the import modal names its heading with this id: the dialog is
// labelled by whichever step is on screen.
export const ID_TITOLO = 'import-haccp-titolo';

// The tile behind an icon: the colour at low opacity.
const tinta = (colore) => fade(colore, 0.12);

/** The layout shared by every step of the import modal. */
const useStili = makeStyles((theme) => {
  const dialog = stiliDialog(theme);
  return {
    ...dialog,
    content: {
      padding: theme.spacing(4, 4, 2),
      textAlign: 'left',
    },
    intestazione: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    icona: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: theme.spacing(5),
      height: theme.spacing(5),
      borderRadius: theme.shape.iconTileRadius,
    },
    iconaErrore: {
      backgroundColor: tinta(theme.palette.error.main),
      color: theme.palette.error.main,
    },
    iconaFile: {
      backgroundColor: tinta(theme.palette.primary.main),
      color: theme.palette.primary.main,
    },
    // Neutral on purpose: the file was not judged, the check did not run.
    iconaIncerta: {
      backgroundColor: theme.palette.neutral.light,
      color: theme.palette.text.secondary,
    },
    titolo: {
      ...dialog.titolo,
      marginBottom: theme.spacing(0.5),
      '&:focus': {
        outline: 'none',
      },
    },
    titoloErrore: {
      color: theme.palette.error.main,
    },
    nota: {
      ...dialog.testo,
      marginTop: theme.spacing(3),
    },
    riquadro: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(2),
    },
    actions: {
      gap: theme.spacing(1.5),
      padding: theme.spacing(2, 4, 4),
    },
    // Pushes the actions after it to the right edge.
    spinta: {
      marginRight: 'auto',
    },
  };
});

export default useStili;
